import { render, staticRenderFns } from "./LiquidIntegration.vue?vue&type=template&id=7fffa0f7&scoped=true&"
import script from "./LiquidIntegration.vue?vue&type=script&lang=js&"
export * from "./LiquidIntegration.vue?vue&type=script&lang=js&"
import style0 from "./LiquidIntegration.vue?vue&type=style&index=0&id=7fffa0f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fffa0f7",
  null
  
)

export default component.exports